module.exports = __webpack_public_path__ + "img/ic_error_user.f67c46af.png";